import IDrmModifiers                from '../Interfaces/IDrmModifiers';
import ILicenseRequest              from '../Interfaces/ILicenseRequest';
import extractMpxTokenFromAuthToken from '../Util/extractMpxTokenFromAuthToken';

const transformLicenseRequest = (request: ILicenseRequest, authToken: string): void => {
    request.uris[0] = `${request.uris[0]}&auth=${extractMpxTokenFromAuthToken(authToken)}`;
};

const createShakaPlayreadyDrmModifiers = (licenseRequestType: number, authToken: string): IDrmModifiers => ({
    licenseRequest: (requestType, request) =>
        requestType === licenseRequestType && transformLicenseRequest(request, authToken)
});

export {
    createShakaPlayreadyDrmModifiers,
    transformLicenseRequest
};